var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxdesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.99 54.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #2e002f;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #ffa0ff;\n      }\n\n      .cls-4 {\n        fill: #2e002f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.97,28.38c-.37-5.36-3.87-9.69-8.9-11.09-.28-.08-.55-.12-.82-.16-.13-.08-.26-.15-.38-.25-.41-.31-.86-.51-1.34-.62-7.13-5.09-19.78-4.29-27.96-2.41-.76,0-1.52.02-2.27.04-.06-.03-.12-.05-.18-.08-3.38-1.28-7.15-3.03-11.04-4.3-6.02-2.24-12.85-3.18-18.69-1.12C3.5,9.77.71,12.66.12,16.35c-.72,4.51,1.77,8.83,4.33,12.58.07,3.04,1.77,6.2,3.76,8.43,3.45,3.87,8.56,6.17,13.98,7.07,7.72,1.29,16.27.97,24.4-.31.33.05.68.06,1.06.03,5.39-.38,10.11,3.53,15.61,3.19,4.97-.31,8.04-3.27,9.51-7.63.38-.61.72-1.24,1-1.9.04-.04.07-.07.11-.11.03-.03.05-.06.08-.1.98-.45,1.89-1.02,2.69-1.84,1.8-1.84,2.49-4.84,2.32-7.38Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.36,1.56l11.63,11.51c.09.09.09.25-.02.36L28.89,50.65c-.05.05-12.81,2.47-12.81,2.47-.65.03-1.16-.46-1.15-1.12,0,0,2.03-13.06,2.08-13.11L53.01,1.59c.1-.11.26-.12.35-.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.06,
    y1: 7.76,
    x2: 59.02,
    y2: 19.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.21,
    y1: 38.68,
    x2: 29.15,
    y2: 50.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.02,
    y1: 13.65,
    x2: 22.91,
    y2: 44.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.67,52.81c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.95,51.7l1.49,1.4c.14.15.3.25.48.31.18.09.37.14.58.13.21,0,.4-.04.58-.13.19-.06.35-.16.48-.31.26-.29.46-.66.44-1.06l-.05-.4c-.07-.25-.2-.47-.39-.66l-1.49-1.4c-.14-.15-.3-.25-.48-.31-.18-.09-.37-.14-.58-.13-.21,0-.4.04-.58.13-.19.06-.35.16-.48.31-.26.29-.46.66-.44,1.06l.05.4c.07.25.2.47.39.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.82,51.24c.56.5,1.07,1.04,1.53,1.64l-.23-.3s.04.05.06.07c.09.17.22.32.39.42.14.13.31.22.51.27.2.06.4.07.6.03.2,0,.39-.07.56-.18.32-.21.6-.51.69-.9l.05-.4c0-.27-.07-.52-.2-.76-.55-.73-1.14-1.41-1.83-2.02-.14-.15-.3-.25-.48-.31-.18-.09-.37-.14-.58-.13-.21,0-.4.04-.58.13-.19.06-.35.16-.48.31-.26.29-.46.66-.44,1.06s.14.8.44,1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.15,51.56c.12.04.24.08.35.13l-.36-.15c.29.12.57.29.82.48l-.3-.23c.25.2.47.42.67.67l-.23-.3c.18.24.33.49.45.76.09.17.22.32.39.42.14.13.31.22.51.27.2.06.4.07.6.03.2,0,.39-.07.56-.18.32-.21.6-.51.69-.9l.05-.4c0-.27-.07-.52-.2-.76-.11-.25-.25-.49-.41-.71-.23-.31-.47-.62-.76-.88-.59-.52-1.26-.91-2.02-1.14-.37-.11-.83-.04-1.16.15s-.61.54-.69.9c-.09.38-.07.81.15,1.16s.51.57.9.69h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxdesign);
export default __webpack_public_path__ + "static/media/uxdesign.4ae2bb4ede0958734654adb84016e23f.svg";
export { ForwardRef as ReactComponent };